import { render, staticRenderFns } from "./EquipeComponent.vue?vue&type=template&id=5269dde0"
import script from "./EquipeComponent.vue?vue&type=script&lang=js"
export * from "./EquipeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports